import { clearAdvancedWelcomeTourState } from "./advancedWelcomeTourStorage";
import { clearTourProgress } from "./onboardingTourProgress";

const STORAGE_VERSION = 1;

export const ONBOARDING_OPEN_EVENT = "onboarding-tutorial:open";

function restaurantScope() {
  return localStorage.getItem("restaurantId") || "default";
}

function scopedKey(suffix) {
  return `onboardingTutorial:${STORAGE_VERSION}:${suffix}:${restaurantScope()}`;
}

export function hasOnboardingQrGenerated() {
  return localStorage.getItem(scopedKey("qrGenerated")) === "true";
}

export function markOnboardingQrGenerated() {
  localStorage.setItem(scopedKey("qrGenerated"), "true");
}

export function isOnboardingTutorialComplete() {
  return localStorage.getItem(scopedKey("allComplete")) === "true";
}

export function markOnboardingTutorialComplete() {
  localStorage.setItem(scopedKey("allComplete"), "true");
}

export function isOnboardingSessionDismissed() {
  return sessionStorage.getItem(scopedKey("sessionDismiss")) === "true";
}

export function dismissOnboardingForSession() {
  sessionStorage.setItem(scopedKey("sessionDismiss"), "true");
}

export function clearOnboardingSessionDismiss() {
  sessionStorage.removeItem(scopedKey("sessionDismiss"));
}

/** Clear dismiss flags and reopen the guide panel. */
export function openOnboardingTutorial() {
  clearOnboardingSessionDismiss();
  window.dispatchEvent(new CustomEvent(ONBOARDING_OPEN_EVENT));
}

/**
 * Reset tutorial UI state so the guide opens from the beginning.
 * Step completion still reflects your real account data (profile, menu, QR downloads).
 */
export function resetOnboardingTutorial({ resetQrStep = true } = {}) {
  localStorage.removeItem(scopedKey("allComplete"));
  if (resetQrStep) {
    localStorage.removeItem(scopedKey("qrGenerated"));
  }
  clearTourProgress();
  clearAdvancedWelcomeTourState();
  clearOnboardingSessionDismiss();
  window.dispatchEvent(new CustomEvent(ONBOARDING_OPEN_EVENT));
  window.dispatchEvent(new CustomEvent("onboarding-tour:progress"));
}
